<p-toast></p-toast>
<p-progressBar mode="indeterminate" *ngIf="isLoading"></p-progressBar>

<app-page-shell *ngIf="!isLoading">

    <app-page-detail-hero [auditStamp]="deliveryAuditStamp()"
        [eyebrow]="'pages.deliveryDetail.hero.eyebrow' | transloco"
        [title]="'pages.deliveryDetail.hero.title' | transloco:{ number: shipmentDelivery.deliveryNumber }"
        [subtitle]="'pages.deliveryDetail.hero.subtitle' | transloco:{ number: shipmentNumber() }"
        icon="fa-solid fa-truck-moving">
        <div tags>
            <p-tag [value]="currentWorkflowState()" [severity]="getStatusSeverity(currentWorkflowState())"></p-tag>
            <p-tag [value]="shipmentDelivery.actualBookingOption || shipment.requestedBookingOption || ('pages.deliveryDetail.hero.bookingPending' | transloco)" severity="info"></p-tag>
            <p-tag *ngIf="shipmentDelivery.waybillNumber" [value]="'Waybill: ' + shipmentDelivery.waybillNumber" severity="success"></p-tag>
            <p-tag *ngIf="hasLogisticsProject()" [value]="logisticsProjectTagLabel()" severity="contrast"></p-tag>
            <p-tag *ngIf="hasHistoricalWaybill()" [value]="'pages.deliveryDetail.hero.historicalWaybill' | transloco" severity="warn"></p-tag>
        </div>
        <div actions>
            <p-button [label]="'pages.deliveryDetail.hero.backToDeliveries' | transloco" icon="pi pi-list"
                severity="secondary" [outlined]="true" routerLink="/shipment/deliveries"></p-button>
            <p-button [label]="'pages.deliveryDetail.hero.backToShipment' | transloco" icon="pi pi-arrow-left" severity="secondary" [outlined]="true"
                [disabled]="!shipment?.shipmentId" (onClick)="backToShipment()"></p-button>
        </div>
    </app-page-detail-hero>

    <div class="cancellation-alert-banner" *ngIf="isCancelled()">
        <i class="fa-solid fa-ban"></i>
        <div class="cancellation-alert-copy">
            <strong>{{ isShipmentCancelled() ? ('pages.deliveryDetail.cancellationBanner.shipmentCancelledTitle' | transloco) : ('pages.deliveryDetail.cancellationBanner.deliveryCancelledTitle' | transloco) }}</strong>
            <span>{{ 'pages.deliveryDetail.cancellationBanner.lockedSubtitle' | transloco }}</span>
        </div>
    </div>

    @if (shipmentInboundRequests.length) {
    <section class="surface-card border-1 surface-border border-round p-3 mb-3" aria-label="Inbound warehouse work">
        <strong>Inbound warehouse work</strong>
        @for (request of shipmentInboundRequests; track request.id) {
        <div class="flex flex-wrap align-items-center gap-3 mt-2">
            <span>Warehouse #{{ request.warehouseId }} · {{ request.status }}</span>
            @for (line of request.lines; track line.id) {
                @if (line.inboundReceiptId) {
                <a [routerLink]="['/warehousing/stock-entry/view', line.inboundReceiptId]">{{ line.receiptNumber || ('GRN #' + line.inboundReceiptId) }}</a>
                }
            }
        </div>
        }
    </section>
    }

    <div class="delivery-detail-layout">
        <main class="delivery-detail-main">
    <app-page-metric-strip [metrics]="deliveryMetrics()"></app-page-metric-strip>

    <app-page-data-panel class="delivery-workspace-panel" [title]="'pages.deliveryDetail.workspace.title' | transloco" [subtitle]="'pages.deliveryDetail.workspace.subtitle' | transloco">
            <p-tabs [value]="activeTabIndex" (valueChange)="onTabChange({ index: $event })" styleClass="delivery-tabs">
                <p-tablist>
                    <p-tab [value]="0">
                        <span class="delivery-tab"><i class="fa-solid fa-map-location-dot"></i><span>{{ 'pages.deliveryDetail.workspace.tabs.control' | transloco }}</span><p-badge [value]="'pages.deliveryDetail.workspace.live' | transloco" severity="danger"></p-badge></span>
                    </p-tab>
                    <p-tab [value]="9">
                        <span class="delivery-tab"><i class="fa-solid fa-timeline"></i><span>{{ 'pages.deliveryDetail.workspace.tabs.timeline' | transloco }}</span><p-badge [value]="timelineProgress().toString() + '%'" severity="info"></p-badge></span>
                    </p-tab>
                    <p-tab [value]="7">
                        <span class="delivery-tab"><i class="fa-solid fa-location-crosshairs"></i><span>{{ 'pages.deliveryDetail.workspace.tabs.tracking' | transloco }}</span><p-badge [value]="trackingStatusLabel()" [severity]="trackingStatusSeverity()"></p-badge></span>
                    </p-tab>
                    <p-tab [value]="1">
                        <span class="delivery-tab"><i class="fa-solid fa-id-card"></i><span>{{ 'pages.deliveryDetail.workspace.tabs.crewAsset' | transloco }}</span></span>
                    </p-tab>
                    <p-tab [value]="2">
                        <span class="delivery-tab"><i class="fa-solid fa-file-lines"></i><span>{{ 'pages.deliveryDetail.workspace.tabs.files' | transloco }}</span><p-badge [value]="deliveryFilesCount.toString()" [severity]="deliveryFilesCount > 0 ? 'success' : 'info'"></p-badge></span>
                    </p-tab>
                    <p-tab [value]="8">
                        <span class="delivery-tab"><i class="fa-solid fa-boxes-stacked"></i><span>{{ 'pages.deliveryDetail.workspace.tabs.payload' | transloco }}</span><p-badge [value]="payloadCount().toString()" [severity]="payloadCount() > 0 ? 'info' : 'secondary'"></p-badge></span>
                    </p-tab>
                    <p-tab [value]="10" *ngIf="hasDeliveryContainerCases() || (deliveryContainerCasesError && canViewContainerCases())">
                        <span class="delivery-tab"><i class="fa-solid fa-box"></i><span>{{ 'pages.deliveryDetail.workspace.tabs.containers' | transloco }}</span><p-badge [value]="deliveryContainerCases.length.toString()" [severity]="deliveryContainerCases.length > 0 ? 'info' : 'secondary'"></p-badge></span>
                    </p-tab>
                    <p-tab [value]="11" *ngIf="hasDeliveryFieldWork() || (deliveryFieldWorkError && canViewFieldWork())">
                        <span class="delivery-tab"><i class="fa-solid fa-people-carry-box"></i><span>{{ 'fieldWork.title' | transloco }}</span><p-badge [value]="deliveryFieldWorkPackages.length.toString()" severity="info"></p-badge></span>
                    </p-tab>
                    <p-tab [value]="3" *ngIf="canViewShipmentPricing()">
                        <span class="delivery-tab"><i class="fa-solid fa-money-bill-transfer"></i><span>{{ 'pages.deliveryDetail.workspace.tabs.charges' | transloco }}</span><p-badge [value]="deliveryChargeLines().length.toString()" [severity]="deliveryChargeLines().length > 0 ? 'success' : 'danger'"></p-badge></span>
                    </p-tab>
                    <p-tab [value]="5">
                        <span class="delivery-tab"><i class="fa-solid fa-signature"></i><span>{{ 'pages.deliveryDetail.workspace.tabs.pod' | transloco }}</span><p-badge *ngIf="actionData()?.receiverName" severity="success" [value]="'pages.deliveryDetail.workspace.verified' | transloco"></p-badge></span>
                    </p-tab>
                    <p-tab [value]="6">
                        <span class="delivery-tab"><i class="fa-solid fa-note-sticky"></i><span>{{ 'pages.deliveryDetail.workspace.tabs.notes' | transloco }}</span></span>
                    </p-tab>
                </p-tablist>

                <p-tabpanels>
                    <p-tabpanel [value]="0">
                        <section class="workspace-section">
                            <div class="route-summary">
                                <div>
                                    <span>{{ 'pages.deliveryDetail.control.pickup' | transloco }}</span>
                                    <strong>{{ sourceLocationName() }}</strong>
                                    <small>{{ sourceLocationAddress() }}</small>
                                </div>
                                <div>
                                    <span>{{ 'pages.deliveryDetail.control.dropoff' | transloco }}</span>
                                    <strong>{{ destinationLocationName() }}</strong>
                                    <small>{{ destinationLocationAddress() }}</small>
                                </div>
                                <div>
                                    <span>{{ 'pages.deliveryDetail.control.plannedDistance' | transloco }}</span>
                                    <strong>{{ routeDistanceLabel() }}</strong>
                                    <small>{{ routeDurationLabel() }}</small>
                                </div>
                                <div>
                                    <span>{{ 'pages.deliveryDetail.control.liveEta' | transloco }}</span>
                                    <strong>{{ liveTrackingEta() || ('pages.deliveryDetail.control.unavailable' | transloco) }}</strong>
                                    <small>{{ liveTrackingDistance() || ('pages.deliveryDetail.control.distancePending' | transloco) }}</small>
                                </div>
                            </div>


                            <div class="delivery-stop-list">
                                <div class="section-toolbar">
                                    <div>
                                        <h3>{{ 'pages.deliveryDetail.control.deliveryStops' | transloco }}</h3>
                                        <p>{{ 'pages.deliveryDetail.control.deliveryStopsSummary' | transloco:{ count: deliveryStops.length } }}</p>
                                    </div>
                                    <div class="flex align-items-center gap-2">
                                        <p-tag [value]="currentWorkflowState()" severity="info"></p-tag>
                                    </div>
                                </div>

                                @if (deliveryWaybillsLoading) {
                                <div class="delivery-panel-state">Loading waybill status...</div>
                                } @else if (deliveryWaybillsError) {
                                <div class="delivery-panel-state delivery-panel-state--error">Waybill status could not be loaded. <button type="button" (click)="retryDeliveryWaybills()">Retry</button></div>
                                } @else if (deliveryWaybillSummary.deliveries.length > 0) {
                                <section class="delivery-waybill-summary" aria-label="Waybills by site">
                                    <strong>{{ 'pages.shipmentDetail.overview.waybillsBySite' | transloco }}</strong>
                                    @for (delivery of deliveryWaybillSummary.deliveries; track delivery.deliveryId) {
                                        @for (site of delivery.sites; track site.stopId) {
                                        <div>
                                            <span>{{ site.stopType || 'SITE' }} {{ site.stopNumber ? ('#' + site.stopNumber) : '' }} · {{ site.locationName || 'Location pending' }}</span>
                                            @if (site.issued) { <p-tag [value]="site.waybillNumbers.join(', ')" severity="success"></p-tag> }
                                            @else { <p-tag [value]="'pages.shipmentDetail.overview.noWaybillIssued' | transloco" severity="secondary"></p-tag> }
                                        </div>
                                        }
                                    }
                                </section>
                                }

                                @if (deliveryStops.length > 0) {
                                <div class="stop-grid">
                                    @for (stop of deliveryStops; track stop.stopId) {
                                    <article class="stop-card">
                                        <div class="stop-card-header">
                                            <div>
                                                <span>{{ stop.stopPurpose === 'REJECTION_RETURN' ? 'RETURN' : stop.stopPurpose === 'REVISIT' ? 'REVISIT' : (stop.stopType || 'STOP') }} #{{ stop.stopNumber }}</span>
                                                <strong>{{ stop.locationName || (('pages.deliveryDetail.control.locationFallback' | transloco) + ' ' + (stop.locationId || '-')) }}</strong>
                                            </div>
                                            <div class="flex align-items-center gap-2">
                                                @if (stop.stopPurpose === 'REJECTION_RETURN') {
                                                <p-tag [value]="stop.returnDestinationConfirmedAt ? 'Return destination confirmed' : 'Awaiting office confirmation'"
                                                    [severity]="stop.returnDestinationConfirmedAt ? 'success' : 'warn'"></p-tag>
                                                } @else if (stop.stopPurpose === 'REVISIT') {
                                                <p-tag value="Required revisit" severity="warn"></p-tag>
                                                } @else if (stop.stopOrigin === 'DELIVERY_AD_HOC') {
                                                <p-tag value="Delivery only" severity="info"></p-tag>
                                                }
                                                @if (stop.waybillNumber) {
                                                <p-tag [value]="'Waybill: ' + stop.waybillNumber" severity="success"></p-tag>
                                                }
                                                <p-tag [value]="stop.workflowState || 'PENDING'" [severity]="getStatusSeverity(stop.workflowState)"></p-tag>
                                            </div>
                                        </div>
                                        <dl>
                                            <div><dt>{{ 'pages.deliveryDetail.control.plannedArrival' | transloco }}</dt><dd>{{ formatStopDate(stop.scheduledArrival) }}</dd></div>
                                            <div><dt>{{ 'pages.deliveryDetail.control.actualArrival' | transloco }}</dt><dd>{{ formatStopDate(stop.actualArrival) }}</dd></div>
                                            <div><dt>{{ 'pages.deliveryDetail.control.evidence' | transloco }}</dt><dd>{{ stop.evidenceStatus || 'PENDING' }}</dd></div>
                                        </dl>
                                        @if ((stop.lineItems || []).length > 0) {
                                        <div class="stop-lines">
                                            @for (line of stop.lineItems; track line.stopLineId) {
                                            <div>
                                                <span>{{ line.action }}</span>
                                                <strong>{{ line.actualQuantity ?? 0 }} / {{ line.plannedQuantity ?? 0 }}</strong>
                                                <small>{{ line.workflowState || 'PLANNED' }}</small>
                                                @if ((line.rejectedQuantity ?? 0) > 0 || (line.rescheduledQuantity ?? 0) > 0) {
                                                <small>Rejected {{ line.rejectedQuantity ?? 0 }} | Rescheduled {{ line.rescheduledQuantity ?? 0 }}</small>
                                                }
                                            </div>
                                            }
                                        </div>
                                        }
                                        <div class="stop-actions">
                                            @if (stop.stopPurpose === 'REJECTION_RETURN' && !stop.returnDestinationConfirmedAt && canManageDeliveryOnlyStops()) {
                                            <button pButton type="button" label="Confirm return destination" icon="pi pi-map-marker"
                                                severity="warn" (click)="openReturnDestinationDialog(stop)"></button>
                                            }
                                            <button pButton type="button" [label]="'pages.deliveryDetail.control.openSite' | transloco" icon="fa-solid fa-arrow-up-right-from-square"
                                                severity="help" [outlined]="true" (click)="openSiteOperation(stop)"></button>
                                            @if (canEditDeliveryOnlyStop(stop)) {
                                            <button pButton type="button" icon="pi pi-pencil" severity="secondary" [text]="true"
                                                pTooltip="Edit delivery-only stop" (click)="openDeliveryOnlyStopDialog(stop)"></button>
                                            <button pButton type="button" icon="pi pi-trash" severity="danger" [text]="true"
                                                pTooltip="Remove delivery-only stop" (click)="removeDeliveryOnlyStop(stop)"></button>
                                            }
                                        </div>
                                    </article>
                                    }
                                </div>
                                } @else {
                                <div class="inline-empty">{{ 'pages.deliveryDetail.control.noOperationalStops' | transloco }}</div>
                                }
                            </div>
                        </section>
                    </p-tabpanel>

                    <p-tabpanel [value]="9">
                        <section class="timeline-workspace">
                            <div class="timeline-summary-card">
                                <div class="timeline-progress">
                                    <div>
                                        <span>{{ 'pages.deliveryDetail.control.progress' | transloco }}</span>
                                        <strong>{{ timelineProgress() }}%</strong>
                                    </div>
                                    <div class="progress-track">
                                        <div class="progress-fill" [style.width.%]="timelineProgress()"></div>
                                    </div>
                                </div>
                                <div class="timeline-phase-summary">
                                    <span>{{ 'pages.deliveryDetail.control.currentPhase' | transloco }}</span>
                                    <strong>{{ currentPhase() }}</strong>
                                    <small>{{ liveTrackingEta() ? ('ETA ' + liveTrackingEta() + ' / ' + liveTrackingDistance()) : ('pages.deliveryDetail.control.liveEtaUnavailable' | transloco) }}</small>
                                </div>
                            </div>

                            @if (hasAlerts()) {
                            <div class="alert-stack timeline-alerts">
                                @for (alert of alerts(); track alert) {
                                <div><i class="pi pi-exclamation-triangle"></i><span>{{ alert }}</span></div>
                                }
                            </div>
                            }

                            <div class="timeline-status-grid">
                                <div>
                                    <span>{{ 'pages.deliveryDetail.control.shipment' | transloco }}</span>
                                    <strong>{{ shipmentWorkflowState() }}</strong>
                                </div>
                                <div>
                                    <span>{{ 'pages.deliveryDetail.control.delivery' | transloco }}</span>
                                    <strong>{{ currentWorkflowState() }}</strong>
                                </div>
                                <div>
                                    <span>{{ 'pages.deliveryDetail.control.site' | transloco }}</span>
                                    <strong>{{ activeOrNextStopLabel() }}</strong>
                                    @if (operationStatus?.nextStopSource === 'DRIVER_SELECTED' && !operationStatus?.activeStop) {
                                        <span>{{ 'pages.deliveryDetail.control.driverSelected' | transloco }}</span>
                                    }
                                </div>
                                <div>
                                    <span>{{ 'pages.deliveryDetail.control.orderRelease' | transloco }}</span>
                                    <strong>{{ orderReleaseStatusLabel() }}</strong>
                                </div>
                                <div>
                                    <span>{{ 'pages.deliveryDetail.control.pickup' | transloco }}</span>
                                    <strong>{{ pickupProgressLabel() }}</strong>
                                </div>
                                <div>
                                    <span>{{ 'pages.deliveryDetail.control.dropoff' | transloco }}</span>
                                    <strong>{{ dropoffProgressLabel() }}</strong>
                                </div>
                            </div>

                            <div class="timeline-main-grid">
                                <section class="timeline-section-card">
                                    <header class="timeline-section-header">
                                        <div>
                                            <h3>{{ 'pages.deliveryDetail.control.routeMilestones' | transloco }}</h3>
                                            <p>{{ 'pages.deliveryDetail.control.routeMilestonesSummary' | transloco:{ count: deliveryStops.length } }}</p>
                                        </div>
                                        <p-tag [value]="currentWorkflowState()" severity="info"></p-tag>
                                    </header>

                                    <div class="milestone-rail">
                                        @for (stop of deliveryStops; track stop.stopId || stop.stopNumber; let index = $index) {
                                        <div class="milestone-row" [class.done]="timelineState(stop) === 'done'" [class.active]="timelineState(stop) === 'active'">
                                            <div class="milestone-marker">
                                                <i [ngClass]="stop.stopType === 'PICKUP' ? 'pi pi-arrow-circle-up' : 'pi pi-arrow-circle-down'"></i>
                                            </div>
                                            <div class="milestone-body">
                                                <strong>{{ stop.stopType || 'STOP' }} #{{ stop.stopNumber }} - {{ stop.locationName || ('pages.deliveryDetail.control.locationFallback' | transloco) }}</strong>
                                                <span>{{ stop.workflowState || 'PENDING' }} / {{ 'pages.deliveryDetail.control.evidence' | transloco }} {{ stop.evidenceStatus || 'PENDING' }}</span>
                                            </div>
                                            <button pButton type="button" icon="fa-solid fa-arrow-up-right-from-square" [rounded]="true" [text]="true"
                                                severity="help" (click)="openSiteOperation(stop)"></button>
                                        </div>
                                        } @empty {
                                        <div class="inline-empty">{{ 'pages.deliveryDetail.control.noOperationalStops' | transloco }}</div>
                                        }
                                    </div>
                                </section>

                                <section class="timeline-section-card">
                                    <header class="timeline-section-header">
                                        <div>
                                            <h3>{{ 'pages.deliveryDetail.timeline.title' | transloco }}</h3>
                                            <p>{{ operationTimelineEvents.length }} workflow events recorded.</p>
                                        </div>
                                    </header>

                                    @if (operationalTimelineGroups().length > 0) {
                                    <div class="workflow-event-groups">
                                        @for (group of operationalTimelineGroups(); track group.key) {
                                        <section class="workflow-event-group">
                                            <header>
                                                <strong>{{ group.title }}</strong>
                                                <span>{{ group.subtitle }}</span>
                                            </header>
                                            @for (event of group.events; track event.eventId || $index) {
                                            <div class="workflow-event-row">
                                                <div>
                                                    <strong>{{ workflowEventLabel(event) }}</strong>
                                                    <span>{{ workflowEventMeta(event) }}</span>
                                                </div>
                                                <time>{{ formatStopDate(event.eventAt) }}</time>
                                            </div>
                                            }
                                        </section>
                                        }
                                    </div>
                                    } @else {
                                    <div class="inline-empty">{{ 'pages.deliveryDetail.timeline.empty' | transloco }}</div>
                                    }
                                </section>
                            </div>
                        </section>
                    </p-tabpanel>

                    <p-tabpanel [value]="7">
                        <app-delivery-tracking-panel
                            [shipment]="shipment"
                            [delivery]="shipmentDelivery"
                            [deliveryId]="deliveryId"
                            (summaryChange)="onTrackingSummaryChange($event)">
                        </app-delivery-tracking-panel>
                    </p-tabpanel>

                    <p-tabpanel [value]="1">
                        <section class="workspace-section">
                            <div class="section-toolbar">
                                <div>
                                    <h3>Crew & Asset</h3>
                                    <p>{{ 'pages.deliveryDetail.crewAsset.description' | transloco }}</p>
                                </div>
                            </div>

                            <div class="crew-asset-grid">
                                <article class="profile-card">
                                    <div class="profile-header">
                                        <p-avatar [image]="driverImage()" size="large" shape="circle"></p-avatar>
                                        <div>
                                            <span>{{ 'pages.deliveryDetail.crewAsset.driver' | transloco }}</span>
                                            <strong>{{ driverName() }}</strong>
                                        </div>
                                    </div>
                                    <dl>
                                        <div><dt>Ownership</dt><dd>{{ driverOwnershipType() }}</dd></div>
                                        <div><dt>Owner</dt><dd>{{ driverOwnerLabel() }}</dd></div>
                                        <div *ngIf="driverAgencyLabel() !== '-'"><dt>Agency</dt><dd>{{ driverAgencyLabel() }}</dd></div>
                                        <div *ngIf="shipmentDelivery.deliveryDriver?.resourceCompanyName"><dt>Source Company</dt><dd>{{ driverResourceCompany() }}</dd></div>
                                        <div><dt>Phone</dt><dd>{{ driverPhone() }}</dd></div>
                                        <div><dt>Nationality</dt><dd>{{ driverNationality() }}</dd></div>
                                        <div><dt>Iqama</dt><dd>{{ driverResidenceNumber() }}</dd></div>
                                        <div><dt>Iqama Expiry</dt><dd>{{ driverResidenceExpiry() }}</dd></div>
                                        <div><dt>License Expiry</dt><dd>{{ driverLicenseExpiry() }}</dd></div>
                                    </dl>
                                    <div class="document-strip">
                                        <a *ngIf="shipmentDelivery.deliveryDriver?.residenceImage" [href]="shipmentDelivery.deliveryDriver.residenceImage" target="_blank">{{ 'pages.deliveryDetail.crewAsset.iqamaImage' | transloco }}</a>
                                        <a *ngIf="shipmentDelivery.deliveryDriver?.licenseImage" [href]="shipmentDelivery.deliveryDriver.licenseImage" target="_blank">{{ 'pages.deliveryDetail.crewAsset.licenseImage' | transloco }}</a>
                                    </div>
                                </article>

                                <article class="profile-card">
                                    <div class="profile-header">
                                        <img [src]="vehicleImage()" alt="">
                                        <div>
                                            <span>{{ 'pages.deliveryDetail.crewAsset.vehicle' | transloco }}</span>
                                            <strong>{{ vehiclePlateNumber() }}</strong>
                                        </div>
                                    </div>
                                    <dl>
                                        <div><dt>Ownership</dt><dd>{{ vehicleOwnershipType() }}</dd></div>
                                        <div><dt>Owner</dt><dd>{{ vehicleOwnerLabel() }}</dd></div>
                                        <div *ngIf="vehicleAgencyLabel() !== '-'"><dt>Agency</dt><dd>{{ vehicleAgencyLabel() }}</dd></div>
                                        <div *ngIf="shipmentDelivery.deliveryVehicle?.resourceCompanyName"><dt>Source Company</dt><dd>{{ vehicleResourceCompany() }}</dd></div>
                                        <div><dt>Type</dt><dd>{{ vehicleTypeLabel() }}</dd></div>
                                        <div><dt>Vehicle</dt><dd>{{ vehicleName() }}</dd></div>
                                        <div><dt>Engine</dt><dd>{{ vehicleEngineNumber() }}</dd></div>
                                        <div><dt>Registration</dt><dd>{{ vehicleRegistrationNumber() }}</dd></div>
                                        <div><dt>Reg. Expiry</dt><dd>{{ vehicleRegistrationExpiry() }}</dd></div>
                                    </dl>
                                    <div class="document-strip">
                                        <a *ngIf="shipmentDelivery.deliveryVehicle?.registrationImage" [href]="shipmentDelivery.deliveryVehicle.registrationImage" target="_blank">{{ 'pages.deliveryDetail.crewAsset.registrationImage' | transloco }}</a>
                                        <a *ngIf="firstVehicleImage()" [href]="firstVehicleImage()!" target="_blank">{{ 'pages.deliveryDetail.crewAsset.vehicleImages' | transloco }}</a>
                                    </div>
                                </article>
                            </div>
                            <app-field-resources-panel
                                targetType="SHIPMENT_DELIVERY"
                                [targetId]="shipmentDelivery.deliveryId"
                                [targetReference]="shipmentDelivery.deliveryNumber"
                                [logisticsProjectId]="shipmentDelivery.logisticsProjectId"
                                [customerCrmClientId]="shipment?.crmClientId"
                                [locationId]="shipment?.destinationLocation?.id"
                                [locationName]="shipment?.destinationLocation?.name"
                                [defaultDriverId]="shipmentDelivery.deliveryDriver?.id"
                                [locationOptions]="deliveryFieldWorkLocationOptions">
                            </app-field-resources-panel>
                        </section>
                    </p-tabpanel>

                    <p-tabpanel [value]="2">
                        <section class="workspace-section">
                            <div class="section-toolbar">
                                <div>
                                    <h3>{{ 'pages.deliveryDetail.filesCard.title' | transloco }}</h3>
                                    <p>{{ 'pages.deliveryDetail.filesCard.subtitle' | transloco }}</p>
                                </div>
                                <div class="file-actions">
                                    <p-button [label]="'pages.deliveryDetail.filesCard.openBayanPdf' | transloco" icon="fa-solid fa-arrow-up-right-from-square" severity="secondary" [outlined]="true"
                                        *ngIf="shipmentDelivery.govtWaybillUrl"
                                        (onClick)="openExternalUrl(shipmentDelivery.govtWaybillUrl)"></p-button>
                                    <p-button [label]="'pages.deliveryDetail.filesCard.addFile' | transloco" severity="help" icon="fa-solid fa-plus"
                                        *ngIf="!isCancelled() && permissionService.hasPermission(app_permissions.shipments.files.create)"
                                        (onClick)="addNewFile()"></p-button>
                                </div>
                            </div>

                            @if (hasHistoricalWaybill()) {
                            <div class="historical-waybill-banner">
                                <div>
                                    <strong>{{ 'pages.deliveryDetail.filesCard.historicalWaybillActive' | transloco }}</strong>
                                    <span>{{ 'pages.deliveryDetail.filesCard.suppressedSubtitle' | transloco }}</span>
                                </div>
                                @if (latestHistoricalWaybill()?.fileUrl) {
                                <a [href]="latestHistoricalWaybill()?.fileUrl" target="_blank" rel="noopener">{{ 'pages.deliveryDetail.filesCard.openLatestFile' | transloco }}</a>
                                }
                            </div>
                            }

                            @if (shipmentDeliveryAttachments.length > 0) {
                            <div class="file-grid">
                                @for (orderFile of shipmentDeliveryAttachments; track orderFile.fileUrl) {
                                <div class="file-tile">
                                    <app-attachment-preview [url]="orderFile.fileUrl" [name]="orderFile.fileName"></app-attachment-preview>
                                    <a [href]="orderFile.fileUrl" target="_blank" rel="noopener">
                                        <strong>{{ orderFile.fileName }}</strong>
                                        <span>{{ orderFile.fileType || 'Attachment' }}</span>
                                        <small>{{ showDate(orderFile.creationDate) }}</small>
                                        <div class="file-stop-tag" [class.delivery-level]="!attachmentStop(orderFile)">
                                            <i [class]="attachmentStopIcon(orderFile)"></i>
                                            <div>
                                                <strong>{{ attachmentStopLabel(orderFile) }}</strong>
                                                <span>{{ attachmentStopSubtitle(orderFile) }}</span>
                                            </div>
                                        </div>
                                    </a>
                                    <button pButton type="button" icon="pi pi-trash" severity="danger" [rounded]="true" [text]="true"
                                        *ngIf="permissionService.hasPermission(app_permissions.shipments.files.create)"
                                        pTooltip="Delete attachment"
                                        (click)="deleteAttachment(orderFile)"></button>
                                </div>
                                }
                            </div>
                            } @else {
                            <div class="empty-state">
                                <i class="fa-solid fa-paperclip"></i>
                                <strong>{{ 'pages.deliveryDetail.filesCard.emptyTitle' | transloco }}</strong>
                                <span>{{ 'pages.deliveryDetail.filesCard.emptySubtitle' | transloco }}</span>
                            </div>
                            }
                        </section>
                    </p-tabpanel>

                    <p-tabpanel [value]="8">
                        <section class="workspace-section">
                            <app-payload-ledger
                                [items]="deliveryPayloadItems()"
                                [configuration]="deliveryPayloadLedgerConfiguration"
                                [extracting]="payloadExtractionInProgress"
                                (extractDocument)="onDeliveryPayloadDocumentSelected($event)"
                                (add)="payloadLineDialog.openCreate()"
                                (edit)="payloadLineDialog.openEdit($event.item)"
                                (remove)="payloadLineDialog.confirmDelete($event.item)">
                            </app-payload-ledger>
                        </section>
                        <app-payload-line-command-dialog #payloadLineDialog
                            [shipmentId]="shipment?.shipmentId"
                            [deliveryId]="shipmentDelivery?.deliveryId"
                            [shipment]="shipment"
                            [payloadTypes]="payloadTypes"
                            [uomList]="uomList"
                            [weightUnits]="weightUnitList"
                            [disabled]="isCancelled()"
                            (changed)="onDeliveryPayloadChanged($event)">
                        </app-payload-line-command-dialog>
                    </p-tabpanel>
                    <p-tabpanel [value]="10" *ngIf="hasDeliveryContainerCases() || (deliveryContainerCasesError && canViewContainerCases())">
                        <section class="workspace-section">
                            <div class="section-toolbar">
                                <div>
                                    <h3>{{ 'pages.deliveryDetail.containersCard.title' | transloco }}</h3>
                                    <p>{{ 'pages.deliveryDetail.containersCard.subtitle' | transloco }}</p>
                                </div>
                            </div>

                            @if (deliveryContainerCasesLoading) {
                            <div class="inline-empty">{{ 'pages.deliveryDetail.containersCard.loading' | transloco }}</div>
                            } @else if (deliveryContainerCasesError) {
                            <div class="delivery-panel-state delivery-panel-state--error">Container cases could not be loaded. <button type="button" (click)="retryDeliveryContainerCases()">Retry</button></div>
                            } @else if (deliveryContainerCases.length > 0) {
                            <div class="stop-grid">
                                @for (context of deliveryContainerCases; track context.containerCase?.id) {
                                <article class="stop-card">
                                    <header class="stop-card-header">
                                        <div>
                                            <span>Lifecycle case</span>
                                            <strong>{{ context.containerCase?.caseNumber || 'Container case' }}</strong>
                                        </div>
                                        <p-tag [value]="context.containerCase?.status || 'OPEN'" [severity]="getStatusSeverity(context.containerCase?.status)"></p-tag>
                                    </header>

                                    <div class="stop-lines">
                                        <div>
                                            <span>Container</span>
                                            <strong>{{ context.containerCase?.containerNumber || 'Not captured' }}</strong>
                                            <small>{{ context.containerCase?.isoEquipmentType || 'Equipment type pending' }}</small>
                                        </div>
                                        <div>
                                            <span>BL / Booking</span>
                                            <strong>{{ context.containerCase?.billOfLadingNumber || context.containerCase?.bookingNumber || 'Not captured' }}</strong>
                                            <small>{{ context.containerCase?.sealNumber || 'Seal pending' }}</small>
                                        </div>
                                        <div>
                                            <span>Lifecycle state</span>
                                            <strong>{{ context.containerCase?.currentState || 'Case opened' }}</strong>
                                            <small>{{ context.containerCase?.status || 'OPEN' }}</small>
                                        </div>
                                    </div>

                                    @if (deliveryContainerLeg(context); as leg) {
                                    <div class="container-case-delivery-leg">
                                        <i class="fa-solid fa-truck"></i>
                                        <div>
                                            <span>Delivery-linked transport leg</span>
                                            <strong>{{ leg.mode || 'Transport' }}: {{ leg.fromLocationText || 'Origin pending' }} to {{ leg.toLocationText || 'Destination pending' }}</strong>
                                        </div>
                                        <p-tag [value]="leg.status || 'PLANNED'" [severity]="getStatusSeverity(leg.status)"></p-tag>
                                    </div>
                                    } @else {
                                    <div class="container-case-delivery-leg unlinked">
                                        <i class="fa-solid fa-link"></i>
                                        <span>Delivery is related to this lifecycle case; a matching transport leg has not been reconciled yet.</span>
                                    </div>
                                    }

                                    <footer class="stop-actions">
                                        <p-button label="Open Case" icon="fa-solid fa-arrow-up-right-from-square" severity="secondary" [outlined]="true"
                                            [routerLink]="containerCaseRoute(context)"></p-button>
                                    </footer>
                                </article>
                                }
                            </div>
                            }
                        </section>
                    </p-tabpanel>

                    <p-tabpanel [value]="3" *ngIf="canViewShipmentPricing()">
                        <section class="workspace-section">
                            <section class="financial-position" aria-label="Delivery financial position">
                                <div class="financial-position-heading">
                                    <div>
                                        <span>Delivery financial impact</span>
                                        <h3>Revenue, fulfilment cost, and margin</h3>
                                        <p>These are delivery-level charge lines. Shipment selling remains visible on the shipment financials tab.</p>
                                    </div>
                                    <p-tag [value]="deliveryAccountingRouteLabel()"
                                        [severity]="deliveryAccountingRouteSeverity()"></p-tag>
                                </div>

                                <div class="financial-position-cards">
                                    <article class="financial-position-card is-revenue">
                                        <div class="financial-card-icon"><i class="fa-solid fa-arrow-trend-up"></i></div>
                                        <span>Delivery revenue</span>
                                        <strong>{{ formatAmount(currencyCode(), totalSellingCharges()) }}</strong>
                                        <small>Billable delivery charge lines</small>
                                    </article>
                                    <article class="financial-position-card is-cost">
                                        <div class="financial-card-icon"><i class="fa-solid fa-truck-fast"></i></div>
                                        <span>Delivery cost</span>
                                        <strong>{{ formatAmount(currencyCode(), totalBuyingCharges()) }}</strong>
                                        <small>Transport and other fulfilment charges</small>
                                    </article>
                                    <article class="financial-position-card is-margin" [class.is-negative]="commercialMargin() < 0">
                                        <div class="financial-card-icon"><i class="fa-solid fa-scale-balanced"></i></div>
                                        <span>Delivery margin</span>
                                        <strong>{{ formatAmount(currencyCode(), commercialMargin()) }}</strong>
                                        <small>{{ deliveryMarginPercentageLabel() }}</small>
                                    </article>
                                    <article class="financial-position-card is-accounting">
                                        <div class="financial-card-icon"><i class="fa-solid fa-building-columns"></i></div>
                                        <span>Posting impact</span>
                                        <strong>{{ deliveryAccountingRouteTitle() }}</strong>
                                        <small>{{ deliveryAccountingRouteDetail() }}</small>
                                    </article>
                                </div>

                                <div class="financial-breakdown">
                                    <div class="financial-breakdown-group is-cost">
                                        <div class="financial-breakdown-heading">
                                            <i class="fa-solid fa-truck"></i>
                                            <div><span>Transport cost</span><strong>{{ deliveryTransportSourceLabel() }}</strong></div>
                                        </div>
                                        <dl>
                                            <div><dt>Assigned transport cost</dt><dd>{{ formatAmount(deliveryTransportCurrencyCode(), deliveryAssignedTransportCost()) }}</dd></div>
                                            <div><dt>Transport charge lines</dt><dd>{{ formatAmount(currencyCode(), deliveryTransportChargeTotal()) }}</dd></div>
                                        </dl>
                                    </div>
                                    <div class="financial-breakdown-group is-operation">
                                        <div class="financial-breakdown-heading">
                                            <i class="fa-solid fa-receipt"></i>
                                            <div><span>Charge composition</span><strong>How the delivery total is built</strong></div>
                                        </div>
                                        <dl>
                                            <div><dt>Other cost charge lines</dt><dd>{{ formatAmount(currencyCode(), deliveryOtherBuyingChargeTotal()) }}</dd></div>
                                            <div><dt>Billable charge lines</dt><dd>{{ formatAmount(currencyCode(), totalSellingCharges()) }}</dd></div>
                                        </dl>
                                    </div>
                                </div>
                            </section>

                            <div class="charge-ledger">
                                <div class="table-caption table-caption-actions charge-ledger-caption">
                                    <div>
                                        <strong>Charge Lines</strong>
                                        <span>{{ deliveryChargeLines().length }} delivery-level commercial adjustments</span>
                                    </div>
                                    <p-button label="Add Charge" severity="help" icon="fa-solid fa-plus"
                                        *ngIf="!isCancelled() && permissionService.hasPermission(app_permissions.shipments.charges.create)"
                                        (onClick)="addNewChargeLine()"></p-button>
                                </div>

                                @if (deliveryChargeLines().length > 0) {
                                <div class="charge-ledger-list">
                                    @for (chargeLine of deliveryChargeLines(); track chargeLine.chargeLineId || chargeLine.chargeType) {
                                    <article class="charge-ledger-row">
                                        <div class="charge-ledger-main">
                                            <div>
                                                <span>{{ chargeLine.chargeSource === 'PRODUCT' ? 'Catalog Service' : 'Charge Type' }}</span>
                                                <strong>
                                                    {{ chargeLine.chargeSource === 'PRODUCT'
                                                        ? (chargeLine.productName + (chargeLine.variantName ? ' - ' + chargeLine.variantName : ''))
                                                        : formatChargeType(chargeLine) }}
                                                </strong>
                                                <small *ngIf="chargeLine.chargeSource === 'PRODUCT'">
                                                    {{ chargeLine.productCode || 'No product code' }} | {{ formatChargeType(chargeLine) }}
                                                </small>
                                                <small>{{ chargeLine.remarks || 'No remarks added' }}</small>
                                            </div>
                                            <div class="flex align-items-center gap-2 flex-wrap">
                                                <p-tag *ngIf="chargeLine.buyingPriceOverridden || chargeLine.sellingPriceOverridden"
                                                    value="Price override" severity="warn"></p-tag>
                                                <p-tag [value]="shipmentDelivery.deliveryNumber || 'Delivery level'" severity="info"></p-tag>
                                            </div>
                                        </div>

                                        <div class="charge-ledger-grid">
                                            <div>
                                                <span>Buying</span>
                                                <strong class="amount-buying">{{ formatChargeAmount(chargeLine, chargeLine.buyingChargeAmount) }}</strong>
                                                <small>{{ chargeLine.buyingPriceOverridden ? 'Catalog rate overridden' : 'Carrier cost' }}</small>
                                            </div>
                                            <div>
                                                <span>Selling</span>
                                                <strong class="amount-selling">{{ formatChargeAmount(chargeLine, chargeLine.sellingChargeAmount) }}</strong>
                                                <small>{{ chargeLine.sellingPriceOverridden ? 'Catalog rate overridden' : 'Customer billing' }}</small>
                                            </div>
                                            <div>
                                                <span>Margin</span>
                                                <strong [class.amount-selling]="chargeMargin(chargeLine) >= 0" [class.amount-buying]="chargeMargin(chargeLine) < 0">
                                                    {{ formatChargeAmount(chargeLine, chargeMargin(chargeLine)) }}
                                                </strong>
                                                <small>{{ chargeMarginPercent(chargeLine) }}</small>
                                            </div>
                                            <div>
                                                <span>Effective</span>
                                                <strong>{{ showDate(chargeLine.effectiveDate) || 'Not dated' }}</strong>
                                                <small>Delivery level</small>
                                            </div>
                                        </div>

                                        <div class="charge-ledger-actions">
                                            <button pButton type="button" label="Edit Charge" icon="fa-solid fa-pen" severity="secondary" [outlined]="true"
                                                pTooltip="Edit charge" *ngIf="!isCancelled() && permissionService.hasPermission(app_permissions.shipments.charges.create)"
                                                (click)="editChargeLine(chargeLine)"></button>
                                        </div>
                                    </article>
                                    }
                                </div>
                                } @else {
                                <div class="inline-empty charge-ledger-empty">No charge lines have been added.</div>
                                }
                            </div>

                            <p-accordion [multiple]="true" class="block mt-3">
                                <p-accordion-panel value="expenses">
                                    <p-accordion-header>
                                        <div class="summary-accordion-header">
                                            <strong>Expense Breakdown</strong>
                                            <span>Buying cost distribution for this delivery</span>
                                        </div>
                                    </p-accordion-header>
                                    <p-accordion-content>
                                        <p-table [value]="deliveryExpenseRows()" responsiveLayout="scroll">
                                            <ng-template pTemplate="header">
                                                <tr>
                                                    <th>Expense Type</th>
                                                    <th class="text-right">Amount ({{ currencyCode() }})</th>
                                                    <th class="text-right">% of Total Cost</th>
                                                </tr>
                                            </ng-template>
                                            <ng-template pTemplate="body" let-item>
                                                <tr>
                                                    <td class="font-medium">{{ item.type }}</td>
                                                    <td class="text-right">{{ formatAmount(currencyCode(), item.amount) }}</td>
                                                    <td class="text-right"><p-tag [value]="item.percentage + '%'" severity="info"></p-tag></td>
                                                </tr>
                                            </ng-template>
                                            <ng-template pTemplate="emptymessage">
                                                <tr>
                                                    <td colspan="3"><div class="inline-empty">No expense breakdown available.</div></td>
                                                </tr>
                                            </ng-template>
                                        </p-table>
                                    </p-accordion-content>
                                </p-accordion-panel>

                                <p-accordion-panel value="workforce-finance">
                                    <p-accordion-header>
                                        <div class="summary-accordion-header">
                                            <strong>Delivery Workforce Finance</strong>
                                            <span>Trip earnings, accountable cash, handling earnings, and payout state for this delivery</span>
                                        </div>
                                    </p-accordion-header>
                                    <p-accordion-content>
                                        @if (deliveryFinanceLoading) {
                                            <div class="inline-empty">Loading delivery finance…</div>
                                        } @else if (deliveryFinanceError) {
                                            <div class="delivery-panel-state delivery-panel-state--error">Delivery finance could not be loaded. <button type="button" (click)="retryDeliveryFinance()">Retry</button></div>
                                        } @else if (!deliveryFinanceSummary) {
                                            <div class="inline-empty">Workforce Finance is unavailable for this delivery or your role does not have access.</div>
                                        } @else {
                                            <div class="delivery-finance-overview">
                                                <div><span>Trip earning</span><strong>{{ formatAmount(deliveryFinanceSummary.currencyCode, deliveryFinanceSummary.tripEarnings?.[0]?.amount || 0) }}</strong><small>Driver pay · separate from cash</small></div>
                                                <div><span>Driver allowances</span><strong>{{ formatAmount(deliveryFinanceSummary.currencyCode, driverAllowanceRequestedTotal()) }}</strong><small>{{ formatAmount(deliveryFinanceSummary.currencyCode, driverAllowanceIssuedTotal()) }} issued · not driver pay</small></div>
                                                <div><span>Distance pay</span><strong>{{ formatAmount(deliveryFinanceSummary.currencyCode, deliveryFinanceSummary.distanceEarnings?.[0]?.amount || 0) }}</strong><small>GPS / approved distance</small></div>
                                                <div><span>Handling pay</span><strong>{{ formatAmount(deliveryFinanceSummary.currencyCode, handlingEarningTotal()) }}</strong><small>Loading and unloading evidence</small></div>
                                            </div>
                                            @if (deliveryPayTrip) { <div class="delivery-finance-warning">
                                                <i class="pi pi-stopwatch"></i><div>
                                                    <strong>Per-km pay trip #{{ deliveryPayTrip.trip.driverPayTripId }} · {{ deliveryPayTrip.trip.status }}</strong>
                                                    <small class="block">{{ deliveryPayTrip.trip.ratePerKm || 'Rate pending' }} {{ deliveryPayTrip.trip.currencyCode }}/km · {{ deliveryPayTrip.trip.selectedDistanceSource || deliveryPayTrip.trip.intendedDistanceSource }}</small>
                                                    @if (deliveryPayTrip.trip.approvedAmount) { <span>Approved trip total: {{ formatAmount(deliveryPayTrip.trip.currencyCode, deliveryPayTrip.trip.approvedAmount) }} for {{ deliveryPayTrip.trip.approvedDistanceKm }} km. Delivery share: {{ formatAmount(deliveryPayTrip.trip.currencyCode, deliveryPayTripAllocation() ?? deliveryPayTrip.trip.approvedAmount) }}</span> }
                                                    @else if (deliveryPayTrip.plannedDistanceKm && deliveryPayTrip.trip.ratePerKm) { <span>Planned estimate: {{ formatAmount(deliveryPayTrip.trip.currencyCode, deliveryPayTrip.plannedDistanceKm * deliveryPayTrip.trip.ratePerKm) }}; finance confirms final distance.</span> }
                                                    @if (permissionService.hasPermission(app_permissions.accounts.workforce_finance.earnings_manage) && deliveryPayTrip.trip.status !== 'APPROVED') {
                                                        @if (!deliveryPayTrip.trip.startedAt) {
                                                            @if (deliveryPayTrip.trip.intendedDistanceSource === 'PHOTO_ODOMETER') { <label class="block mt-2">Start odometer photo<input class="block mt-1" type="file" accept="image/jpeg,image/png,image/webp" capture="environment" [disabled]="deliveryPayTripBusy" (change)="captureDeliveryPayTrip('START', $event)"></label> }
                                                            @else { <p-button label="Record pay trip start" icon="pi pi-play" size="small" [outlined]="true" [disabled]="deliveryPayTripBusy" (onClick)="captureDeliveryPayTrip('START')"></p-button> }
                                                        }
                                                        @if (deliveryPayTrip.trip.startedAt && !deliveryPayTrip.trip.endedAt) {
                                                            @if (deliveryPayTrip.trip.intendedDistanceSource === 'PHOTO_ODOMETER') { <label class="block mt-2">End odometer photo<input class="block mt-1" type="file" accept="image/jpeg,image/png,image/webp" capture="environment" [disabled]="deliveryPayTripBusy" (change)="captureDeliveryPayTrip('END', $event)"></label> }
                                                            @else { <p-button label="Record pay trip end" icon="pi pi-stop" size="small" [outlined]="true" [disabled]="deliveryPayTripBusy" (onClick)="captureDeliveryPayTrip('END')"></p-button> }
                                                        }
                                                    }
                                                    @if (deliveryPayTripError) { <small class="block text-red-500">{{ deliveryPayTripError }}</small> }
                                                </div>
                                            </div> }
                                            @if ((deliveryFinanceSummary.configurationWarnings || []).length) {
                                                <div class="delivery-finance-warning"><i class="pi pi-exclamation-triangle"></i><div>@for (warning of deliveryFinanceSummary.configurationWarnings; track warning) { <span>{{ warning }}</span> }</div></div>
                                            }
                                            <div class="delivery-finance-grid">
                                                <section>
                                                    <div class="delivery-finance-heading"><div><i class="pi pi-wallet"></i><strong>Trip money</strong><small>Earned pay and purpose-specific cash requests</small></div><p-button [label]="(deliveryFinanceSummary.tripEarnings?.length || deliveryFinanceSummary.cashRequests?.length) ? 'Edit trip money' : 'Add trip money'" icon="pi pi-pencil" size="small" [disabled]="!canManageDeliveryTripMoney()" (onClick)="openTripMoneyDialog()"></p-button></div>
                                                    <p-table [value]="deliveryFinanceSummary.tripEarnings || []" styleClass="p-datatable-sm">
                                                        <ng-template pTemplate="header"><tr><th>Earning</th><th>Rate / source</th><th class="text-right">Amount</th><th>Status</th></tr></ng-template>
                                                        <ng-template pTemplate="body" let-line><tr><td>{{ line.workforcePerson?.displayName || 'Assigned driver' }}</td><td>{{ line.rateBasis }}<small class="block">{{ line.reason || 'Rate-card default' }}</small></td><td class="text-right">{{ formatAmount(line.currencyCode, line.amount || 0) }}</td><td><p-tag [value]="line.status || 'DRAFT'" severity="info"></p-tag></td></tr></ng-template>
                                                        <ng-template pTemplate="emptymessage"><tr><td colspan="4" class="inline-empty">No trip earning has been proposed.</td></tr></ng-template>
                                                    </p-table>
                                                    <div *ngFor="let request of deliveryFinanceSummary.cashRequests || []" class="delivery-finance-warning">
                                                        <small class="block">Cash from: {{ request.pettyCashBoxName || 'Source box not assigned' }}<ng-container *ngIf="request.pettyCashBoxLocationName"> · {{ request.pettyCashBoxLocationName }}</ng-container></small>
                                                        <span>{{ request.purpose === 'COMPANY_EXPENSE_FLOAT' ? 'Company expense float' : 'Advance against pay' }} · {{ formatAmount(request.currencyCode, request.amount) }} · {{ request.status }}</span>
                                                        <p-button label="Open cash handoff" [text]="true" size="small" (onClick)="openWorkforceFinance('PETTY_CASH')"></p-button>
                                                    </div>
                                                    <div *ngFor="let payout of deliveryFinanceSummary.payoutStatements || []" class="delivery-finance-warning">
                                                        <span>Pay {{ payout.statementNumber }} · {{ payout.status }} · {{ formatAmount(payout.currencyCode, payout.remainingDue || 0) }} due</span>
                                                        <p-button label="Open payout" [text]="true" size="small" (onClick)="openWorkforceFinance('PAYOUTS')"></p-button>
                                                    </div>
                                                </section>
                                                <section>
                                                    <div class="delivery-finance-heading"><div><i class="pi pi-chart-line"></i><strong>Work earnings</strong><small>Distance and handling stay itemised for audit</small></div><p-button label="Open earnings" icon="pi pi-external-link" size="small" severity="secondary" [outlined]="true" (onClick)="openWorkforceFinance('EARNINGS')"></p-button></div>
                                                    <p-table [value]="(deliveryFinanceSummary.distanceEarnings || []).concat(deliveryFinanceSummary.handlingEarnings || [])" styleClass="p-datatable-sm">
                                                        <ng-template pTemplate="header"><tr><th>Component</th><th>Quantity / rate</th><th class="text-right">Amount</th><th>Status</th></tr></ng-template>
                                                        <ng-template pTemplate="body" let-line><tr><td>{{ line.earningComponent }}</td><td>{{ line.quantity }} × {{ formatAmount(line.currencyCode, line.unitRate || 0) }}</td><td class="text-right">{{ formatAmount(line.currencyCode, line.amount || 0) }}</td><td><p-tag [value]="line.status || '-'" severity="info"></p-tag></td></tr></ng-template>
                                                        <ng-template pTemplate="emptymessage"><tr><td colspan="4" class="inline-empty">No distance or handling earnings yet.</td></tr></ng-template>
                                                    </p-table>
                                                    <div class="delivery-finance-heading mt-3"><div><i class="pi pi-wallet"></i><strong>Driver allowances</strong><small>Company expense float, separate from driver pay</small></div><p-button label="Open cash" icon="pi pi-external-link" size="small" severity="secondary" [outlined]="true" (onClick)="openWorkforceFinance('PETTY_CASH')"></p-button></div>
                                                    <p-table [value]="deliveryCashAdvances()" styleClass="p-datatable-sm">
                                                        <ng-template pTemplate="header"><tr><th>Allowance</th><th>Source / policy</th><th class="text-right">Requested</th><th class="text-right">Issued</th><th class="text-right">Open</th><th>Status</th></tr></ng-template>
                                                        <ng-template pTemplate="body" let-advance><tr><td>{{ advance.advanceNumber || 'Allowance' }}<small class="block">{{ advance.workforcePerson?.displayName || 'Assigned driver' }}</small></td><td>{{ driverAllowanceSource(advance) }}<small class="block">{{ advance.policyVersion || advance.reason || 'No policy version' }}</small></td><td class="text-right">{{ formatAmount(advance.currencyCode, advance.requestedAmount || 0) }}</td><td class="text-right">{{ formatAmount(advance.currencyCode, advance.issuedAmount || 0) }}</td><td class="text-right">{{ formatAmount(advance.currencyCode, advance.openAmount || 0) }}</td><td><p-tag [value]="advance.status || 'DRAFT'" severity="warn"></p-tag></td></tr></ng-template>
                                                        <ng-template pTemplate="emptymessage"><tr><td colspan="6" class="inline-empty">No driver allowances are linked to this delivery.</td></tr></ng-template>
                                                    </p-table>
                                                    <div class="delivery-finance-heading mt-3"><div><i class="pi pi-receipt"></i><strong>Delivery cash settlements</strong><small>Expenses do not change driver earnings</small></div><p-button label="Open cash" icon="pi pi-external-link" size="small" severity="secondary" [outlined]="true" (onClick)="openWorkforceFinance('SETTLEMENTS')"></p-button></div>
                                                    <p-table [value]="deliveryFinanceSummary.settlements || []" styleClass="p-datatable-sm">
                                                        <ng-template pTemplate="header"><tr><th>Settlement</th><th class="text-right">Claimed</th><th>Return / top-up</th><th>Status</th></tr></ng-template>
                                                        <ng-template pTemplate="body" let-settlement><tr><td>{{ settlement.settlementNumber }}</td><td class="text-right">{{ formatAmount(settlement.currencyCode, settlement.claimedAmount || 0) }}</td><td>{{ formatAmount(settlement.currencyCode, settlement.cashReturnAmount || settlement.topUpAmount || 0) }}</td><td><p-tag [value]="settlement.status || '-'" severity="warn"></p-tag></td></tr></ng-template>
                                                        <ng-template pTemplate="emptymessage"><tr><td colspan="4" class="inline-empty">No delivery cash settlement.</td></tr></ng-template>
                                                    </p-table>
                                                </section>
                                            </div>
                                            <div class="workforce-finance-actions"><p-button label="Open delivery finance" icon="pi pi-external-link" severity="secondary" [outlined]="true" (onClick)="openWorkforceFinance('ACTION_REQUIRED')"></p-button></div>
                                        }
                                    </p-accordion-content>
                                </p-accordion-panel>
                            </p-accordion>
                        </section>
                    </p-tabpanel>

                    <p-tabpanel [value]="5">
                        <section class="workspace-section">
                            <div class="section-toolbar">
                                <div>
                                    <h3>Proof of Delivery</h3>
                                    <p>Upload signed POD documents against each drop-off stop.</p>
                                </div>
                                <p-tag [value]="dropoffStops().length + ' drop-off stop(s)'" severity="info"></p-tag>
                            </div>

                            @if (dropoffStops().length > 0) {
                            <div class="pod-stop-list">
                                @for (stop of dropoffStops(); track stop.stopId || $index) {
                                <article class="pod-stop-card">
                                    <div class="pod-stop-header">
                                        <div>
                                            <span>{{ stopLabel(stop) }}</span>
                                            <strong>{{ podAttachmentsForStop(stop).length }} POD document(s)</strong>
                                        </div>
                                        <div class="pod-stop-actions">
                                            <p-tag [value]="stop.evidenceStatus || 'PENDING'" [severity]="stop.evidenceStatus === 'VERIFIED' ? 'success' : 'warning'"></p-tag>
                                            <p-button label="Upload POD" icon="fa-solid fa-upload" severity="help" [outlined]="true"
                                                *ngIf="!isCancelled() && permissionService.hasPermission(app_permissions.shipments.files.create)"
                                                (onClick)="uploadPodForStop(stop)"></p-button>
                                        </div>
                                    </div>
                                    @if (podAttachmentsForStop(stop).length > 0) {
                                    <div class="pod-document-list">
                                        @for (podFile of podAttachmentsForStop(stop); track podFile.attachmentId || podFile.fileUrl) {
                                        <div class="pod-document-row">
                                            <a [href]="podFile.fileUrl" target="_blank">
                                                <i class="fa-solid fa-file-pdf"></i>
                                                <span>{{ podFile.fileName }}</span>
                                            </a>
                                            <small>{{ showDate(podFile.creationDate) }}</small>
                                        </div>
                                        }
                                    </div>
                                    } @else {
                                    <div class="inline-empty">No signed POD uploaded for this drop-off.</div>
                                    }
                                </article>
                                }
                            </div>
                            } @else {
                            <div class="empty-state">
                                <i class="fa-solid fa-location-dot"></i>
                                <strong>No drop-off stops</strong>
                                <span>Drop-off stops must be available before uploading stop-specific POD documents.</span>
                            </div>
                            }

                            @if (deliveryLevelPodAttachments().length > 0) {
                            <div class="pod-stop-card">
                                <div class="pod-stop-header">
                                    <div>
                                        <span>Delivery-level POD</span>
                                        <strong>{{ deliveryLevelPodAttachments().length }} unassigned document(s)</strong>
                                    </div>
                                </div>
                                <div class="pod-document-list">
                                    @for (podFile of deliveryLevelPodAttachments(); track podFile.attachmentId || podFile.fileUrl) {
                                    <div class="pod-document-row">
                                        <a [href]="podFile.fileUrl" target="_blank">
                                            <i class="fa-solid fa-file-pdf"></i>
                                            <span>{{ podFile.fileName }}</span>
                                        </a>
                                        <small>{{ showDate(podFile.creationDate) }}</small>
                                    </div>
                                    }
                                </div>
                            </div>
                            }

                            @if (actionData()) {
                            <div class="pod-layout">
                                <div class="pod-summary">
                                    <span>Recipient</span>
                                    <strong>{{ actionData()?.receiverName || 'Not Provided' }}</strong>
                                    <div>
                                        <p-tag *ngIf="actionData()?.codeQRReceiverVerified" value="QR Verified" severity="success" icon="pi pi-check"></p-tag>
                                        <p-tag *ngIf="actionData()?.driverDocVerified" value="Docs Verified" severity="info" icon="pi pi-file"></p-tag>
                                    </div>
                                </div>
                                <div class="pod-evidence">
                                    <div>
                                        <span>Recipient Signature</span>
                                        @if (actionData()?.recipientSignatureUrl) {
                                        <p-image [src]="actionData()?.recipientSignatureUrl" alt="Recipient Signature" [preview]="true" width="100%"></p-image>
                                        } @else {
                                        <div class="evidence-empty"><i class="pi pi-pencil"></i><span>No signature captured</span></div>
                                        }
                                    </div>
                                    <div>
                                        <span>Recipient ID Photo</span>
                                        @if (actionData()?.receiverIdPhotoUrl) {
                                        <p-image [src]="actionData()?.receiverIdPhotoUrl" alt="Recipient ID" [preview]="true" width="100%"></p-image>
                                        } @else {
                                        <div class="evidence-empty"><i class="pi pi-id-card"></i><span>No ID photo uploaded</span></div>
                                        }
                                    </div>
                                </div>
                            </div>
                            } @else {
                            <div class="empty-state">
                                <i class="pi pi-spin pi-spinner"></i>
                                <strong>Loading POD details</strong>
                                <span>Proof of delivery data is being loaded.</span>
                            </div>
                            }
                        </section>
                    </p-tabpanel>

                    <p-tabpanel [value]="6">
                        <section class="workspace-section">
                            <div class="section-toolbar">
                                <div>
                                    <h3>Delivery Notes</h3>
                                    <p>Rich delivery-level notes for operational context and exceptions.</p>
                                </div>
                                <p-button label="Save Notes" icon="fa-solid fa-floppy-disk"
                                    *ngIf="!isCancelled()"
                                    [loading]="saveDeliveryRemarksInProgress"
                                    [disabled]="deliveryNotesLoading || deliveryNotesError"
                                    (onClick)="saveDeliveryRemarks()"></p-button>
                            </div>

                            @if (deliveryNotesLoading) {
                            <div class="delivery-panel-state">Loading delivery notes...</div>
                            } @else if (deliveryNotesError) {
                            <div class="delivery-panel-state delivery-panel-state--error">Delivery notes could not be loaded. <button type="button" (click)="retryDeliveryNotes()">Retry</button></div>
                            }

                            <div class="rich-note-card">
                                <p-editor [(ngModel)]="deliveryRemarksHtml" [readonly]="isCancelled() || deliveryNotesLoading || deliveryNotesError" [style]="{ height: '320px' }" styleClass="delivery-note-editor">
                                    <ng-template pTemplate="header">
                                        <span class="ql-formats">
                                            <select class="ql-header" aria-label="Text style">
                                                <option value="1">Heading</option>
                                                <option value="2">Subheading</option>
                                                <option selected>Normal</option>
                                            </select>
                                        </span>
                                        <span class="ql-formats">
                                            <button class="ql-bold note-toolbar-button" type="button">B</button>
                                            <button class="ql-italic note-toolbar-button" type="button"><em>I</em></button>
                                            <button class="ql-underline note-toolbar-button" type="button"><u>U</u></button>
                                        </span>
                                        <span class="ql-formats">
                                            <button class="ql-list note-toolbar-button" value="ordered" type="button">1.</button>
                                            <button class="ql-list note-toolbar-button" value="bullet" type="button">â€¢</button>
                                        </span>
                                        <span class="ql-formats">
                                            <button class="ql-link note-toolbar-button" type="button">Link</button>
                                            <button class="ql-clean note-toolbar-button" type="button">Clear</button>
                                        </span>
                                    </ng-template>
                                </p-editor>
                            </div>
                            @if (deliveryRemarksFeed.entries.length > 0) {
                            <section class="delivery-notes-context">
                                <h4>{{ 'pages.shipmentDetail.overview.relatedNotes' | transloco }}</h4>
                                <p>Shipment and site notes are shown here for context and remain editable at their source.</p>
                                @for (entry of deliveryRemarksFeed.entries; track entry.scope + '-' + (entry.stopId || entry.waypointId || entry.deliveryId || '') + '-' + $index) {
                                <article>
                                    <strong>{{ entry.scope === 'SHIPMENT' ? 'Shipment' : entry.scope === 'DELIVERY' ? 'Delivery' : (entry.locationName || 'Site') }}</strong>
                                    <div [innerHTML]="entry.remarksHtml"></div>
                                </article>
                                }
                            </section>
                            }
                        </section>
                    </p-tabpanel>
                    <p-tabpanel [value]="11" *ngIf="hasDeliveryFieldWork() || (deliveryFieldWorkError && canViewFieldWork())">
                        @if (deliveryFieldWorkError) {
                        <div class="delivery-panel-state delivery-panel-state--error">Field work could not be loaded. <button type="button" (click)="retryDeliveryFieldWork()">Retry</button></div>
                        } @else {
                        <app-field-resources-panel
                            targetType="SHIPMENT_DELIVERY"
                            [targetId]="shipmentDelivery.deliveryId"
                            [targetReference]="shipmentDelivery.deliveryNumber"
                            [logisticsProjectId]="shipmentDelivery.logisticsProjectId"
                            [customerCrmClientId]="shipment?.crmClientId"
                            [locationId]="shipment?.destinationLocation?.id"
                            [locationName]="shipment?.destinationLocation?.name"
                            [defaultDriverId]="shipmentDelivery.deliveryDriver?.id"
                            [locationOptions]="deliveryFieldWorkLocationOptions">
                        </app-field-resources-panel>
                        }
                    </p-tabpanel>
                </p-tabpanels>
            </p-tabs>
        </app-page-data-panel>
        </main>

        <aside class="business-action-pane" [attr.aria-label]="'pages.deliveryDetail.actions.panelTitle' | transloco">
            <header class="business-action-pane__header">
                <span class="business-action-pane__eyebrow">{{ 'pages.deliveryDetail.actions.panelEyebrow' | transloco }}</span>
                <h2>{{ 'pages.deliveryDetail.actions.panelTitle' | transloco }}</h2>
                <p>{{ 'pages.deliveryDetail.actions.panelSubtitle' | transloco }}</p>
            </header>

            <section class="business-action-group business-action-group--primary" *ngIf="canMarkHistoricalCompletion()">
                <div class="business-action-group__heading">
                    <i class="fa-solid fa-route"></i>
                    <div>
                        <strong>{{ 'pages.deliveryDetail.actions.workflowGroup' | transloco }}</strong>
                        <span>{{ 'pages.deliveryDetail.actions.workflowGroupHint' | transloco }}</span>
                    </div>
                </div>
                <p-button [label]="'pages.deliveryDetail.actions.markComplete' | transloco" icon="fa-solid fa-check" severity="success"
                    (onClick)="openHistoricalCompletionDialog()"></p-button>
            </section>

            <section class="business-action-group" *ngIf="canManageDeliveryChanges() && !isDeliveryTerminal()">
                <div class="business-action-group__heading">
                    <i class="fa-solid fa-user-gear"></i>
                    <div>
                        <strong>Delivery management</strong>
                        <span>Change the assigned crew or cancel before site work starts.</span>
                    </div>
                </div>
                <p-button *ngIf="canReplaceDeliveryCrewAsset()" label="Replace Driver / Vehicle" icon="fa-solid fa-user-gear"
                    severity="secondary" [outlined]="true" (onClick)="openCrewAssetDialog()"></p-button>
                <p-button *ngIf="canCancelCurrentDelivery()" label="Cancel Delivery" icon="fa-solid fa-ban"
                    severity="danger" [outlined]="true" (onClick)="openDeliveryCancellationDialog()"></p-button>
                <small class="business-action-group__notice" *ngIf="deliveryCancellationBlockedByExecution()">
                    Cancellation is locked after arrival or site work begins. A replacement requires a reason.
                </small>
            </section>

            <section class="business-action-group" *ngIf="!isCancelled()">
                <div class="business-action-group__heading">
                    <i class="fa-solid fa-truck-ramp-box"></i>
                    <div>
                        <strong>{{ 'pages.deliveryDetail.actions.operationsGroup' | transloco }}</strong>
                        <span>{{ 'pages.deliveryDetail.actions.operationsGroupHint' | transloco }}</span>
                    </div>
                </div>
                <p-button *ngIf="canManageDeliveryOnlyStops()" label="Add operational stop" icon="pi pi-plus"
                    severity="secondary" [outlined]="true" (onClick)="openDeliveryOnlyStopDialog()"></p-button>
                <p-button
                    *ngIf="canViewFieldWork() && (hasDeliveryFieldWork() || canManageFieldWork())"
                    [label]="(hasDeliveryFieldWork() ? 'fieldWork.openWorkbench' : 'fieldWork.addPackage') | transloco"
                    icon="fa-solid fa-people-carry-box"
                    severity="secondary"
                    [outlined]="true"
                    [loading]="deliveryFieldWorkLoading"
                    (onClick)="openDeliveryFieldWork()"></p-button>
                <p-button *ngIf="canCreateContainerCase()" [label]="'pages.deliveryDetail.actions.createContainerCase' | transloco" icon="fa-solid fa-box" severity="secondary" [outlined]="true"
                    (onClick)="openCreateContainerCaseDialog()"></p-button>
                @if (!isCancelled() && unassignedContainers.length) {
                    <p-inputGroup><p-inputGroupAddon><i class="pi pi-box"></i></p-inputGroupAddon><p-iftaLabel>
                        <p-multiSelect inputId="deliveryUnassignedContainers" [(ngModel)]="selectedContainerIds" [options]="unassignedContainers" optionLabel="containerNumber" optionValue="id" display="chip" [showClear]="true" appendTo="body" placeholder="Choose containers" styleClass="w-full"></p-multiSelect>
                        <label for="deliveryUnassignedContainers">Unassigned containers</label>
                    </p-iftaLabel></p-inputGroup>
                    <p-button label="Assign containers" icon="pi pi-check" [disabled]="!selectedContainerIds.length" [loading]="assigningContainers" (onClick)="assignContainers()"></p-button>
                }
            </section>

            <section class="business-action-group" *ngIf="!isCancelled()">
                <div class="business-action-group__heading">
                    <i class="fa-solid fa-file-circle-check"></i>
                    <div>
                        <strong>{{ 'pages.deliveryDetail.actions.documentsGroup' | transloco }}</strong>
                        <span>{{ 'pages.deliveryDetail.actions.documentsGroupHint' | transloco }}</span>
                    </div>
                </div>
                <p-button [label]="'pages.deliveryDetail.actions.generateDeliveryNote' | transloco" icon="fa-solid fa-file-signature" severity="secondary" [outlined]="true"
                    [loading]="deliveryNoteGenerationInProgress"
                    (onClick)="generateDeliveryNote()"></p-button>
                <p-button [label]="'pages.deliveryDetail.actions.reprintWaybill' | transloco" icon="fa-solid fa-print" severity="secondary" [outlined]="true"
                    *ngIf="!hasHistoricalWaybill()"
                    [loading]="waybillReprintInProgress"
                    (onClick)="reprintWaybill()"></p-button>
                <p-button [label]="'pages.deliveryDetail.actions.uploadHistoricalWaybill' | transloco" severity="warn" icon="fa-solid fa-file-arrow-up"
                    *ngIf="!isCancelled() && permissionService.hasPermission(app_permissions.shipments.files.create)"
                    (onClick)="uploadHistoricalWaybill()"></p-button>
            </section>

            <section class="business-action-group" *ngIf="hasLogisticsProject()">
                <div class="business-action-group__heading">
                    <i class="fa-solid fa-arrow-up-right-from-square"></i>
                    <div>
                        <strong>{{ 'pages.deliveryDetail.actions.navigationGroup' | transloco }}</strong>
                        <span>{{ 'pages.deliveryDetail.actions.navigationGroupHint' | transloco }}</span>
                    </div>
                </div>
                <p-splitButton *ngIf="hasMultipleLogisticsProjects()" [label]="'pages.deliveryDetail.actions.openProject' | transloco" icon="fa-solid fa-briefcase"
                    severity="secondary" [outlined]="true" [model]="logisticsProjectMenuItems()"
                    (onClick)="openPrimaryLogisticsProject()"></p-splitButton>
                <p-button *ngIf="!hasMultipleLogisticsProjects()" [label]="'pages.deliveryDetail.actions.openProject' | transloco" icon="fa-solid fa-briefcase" severity="secondary" [outlined]="true"
                    [routerLink]="logisticsProjectRoute()"></p-button>
            </section>
        </aside>
    </div>
</app-page-shell>

<app-waypoint-dialog [addWaypointDialogVisible]="deliveryOnlyStopDialogVisible"
    [newWaypoint]="deliveryOnlyStopWaypoint" [companyLocations]="[]"
    [addWaypointInProgress]="deliveryOnlyStopSaving" purpose="delivery-only"
    (onHide)="hideDeliveryOnlyStopDialog()" (onSave)="saveDeliveryOnlyStop($event)">
</app-waypoint-dialog>

<p-dialog [(visible)]="returnDestinationDialogVisible" [modal]="true" [draggable]="false" [resizable]="false"
    [style]="{ width: 'min(920px, 96vw)' }" [breakpoints]="{ '860px': '96vw' }"
    header="Confirm return destination" styleClass="master-create-dialog return-destination-dialog">
    <div class="master-dialog-body">
        <aside class="master-dialog-summary">
            <div class="summary-icon"><i class="fa-solid fa-rotate-left"></i></div>
            <div><small>Rejected cargo</small><h3>Return handoff</h3>
                <p>The driver can see this stop now. Navigation becomes available after you confirm its destination.</p></div>
            <div class="master-dialog-facts"><div><span>Proposed destination</span>
                <strong>{{ selectedReturnStop?.locationName || 'Original pickup' }}</strong></div></div>
        </aside>
        <div class="master-dialog-form">
            @if (returnDestinationError) {
                <div class="dialog-error" role="alert">{{ returnDestinationError }}</div>
            }
            <p-inputGroup>
                <p-inputGroupAddon><i class="fa-solid fa-location-dot"></i></p-inputGroupAddon>
                <p-iftalabel>
                    <p-select inputId="confirmedReturnLocation" [(ngModel)]="returnDestinationLocationId"
                        appLazyLocationPicker optionLabel="name" optionValue="id" [filter]="true" appendTo="body" styleClass="w-full">
                        <ng-template let-location pTemplate="item">{{ location.name }}</ng-template>
                    </p-select>
                    <label for="confirmedReturnLocation">Return destination *</label>
                </p-iftalabel>
            </p-inputGroup>
        </div>
    </div>
    <ng-template pTemplate="footer">
        <div class="master-dialog-footer">
            <span class="footer-spacer"></span>
            <p-button label="Cancel" severity="secondary" [outlined]="true" (onClick)="returnDestinationDialogVisible = false"></p-button>
            <p-button label="Confirm destination" icon="pi pi-check" [loading]="returnDestinationSaving"
                [disabled]="!returnDestinationLocationId" (onClick)="confirmReturnDestination()"></p-button>
        </div>
    </ng-template>
</p-dialog>

<app-field-work-package-create-dialog
    [(visible)]="fieldWorkCreateVisible"
    [value]="fieldWorkPackageDraft"
    [saving]="fieldWorkCreateSaving"
    [error]="fieldWorkCreateError"
    [locationOptions]="deliveryFieldWorkLocationOptions"
    (submitted)="createDeliveryFieldWork($event)">
</app-field-work-package-create-dialog>

<app-delivery-container-case-dialog
    [(visible)]="containerCaseDialogVisible"
    [deliveryId]="shipmentDelivery?.deliveryId"
    [deliveryNumber]="shipmentDelivery?.deliveryNumber"
    [shipmentNumber]="shipment?.shipmentNumber"
    [releaseNumber]="shipmentDelivery?.primaryTransportReleaseNumber || shipment?.primaryTransportReleaseNumber"
    [routeLabel]="(shipment?.pickupCity || getLocationShortAddress(shipment?.pickupAddress) || 'Origin') + ' to ' + (shipment?.dropoffCity || getLocationShortAddress(shipment?.dropoffAddress) || 'Destination')"
    (created)="onContainerCaseCreated($event)">
</app-delivery-container-case-dialog>

<p-dialog
    [(visible)]="tripMoneyDialogVisible"
    header="Delivery trip money"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [style]="{ width: 'min(1260px, 96vw)' }"
    styleClass="master-create-dialog delivery-trip-money-dialog">
    <section class="delivery-trip-money-body">
        <aside class="delivery-trip-money-summary">
            <div class="summary-icon"><i class="pi pi-wallet"></i></div>
            <small>WORKFORCE FINANCE · DELIVERY</small>
            <h3>Trip money</h3>
            <p>Choose fixed, destination, or per-km driver pay and any separate cash request. Saving never issues cash.</p>
            <div class="master-dialog-facts">
                <div><span>Delivery</span><strong>{{ shipmentDelivery?.deliveryNumber || '-' }}</strong></div>
                <div><span>Driver</span><strong>{{ driverName() }}</strong></div>
                <div><span>Cash issue</span><strong>Finance approval required</strong></div>
            </div>
        </aside>
        <section class="delivery-trip-money-form">
            <div class="dialog-section-heading"><h4>Proposal</h4><p>Choose how the driver earns pay. A cash request is a separate handoff.</p></div>
            <div class="delivery-trip-money-toggle">
                <p-checkbox inputId="deliveryTripEnabled" [(ngModel)]="tripMoneyDraft.enabled" [binary]="true"></p-checkbox>
                <label for="deliveryTripEnabled"><strong>Propose trip money for this delivery</strong><small>Create a draft earning when a rate card matches.</small></label>
            </div>
            @if (tripMoneyDraft.enabled !== false) {
            <div class="delivery-trip-money-grid">
                <p-inputGroup><p-inputGroupAddon><i class="pi pi-list"></i></p-inputGroupAddon><p-iftalabel>
                    <p-select inputId="deliveryPayMethod" [(ngModel)]="tripMoneyDraft.payMethod" [options]="driverPayMethods" optionLabel="label" optionValue="value" appendTo="body" styleClass="w-full" (ngModelChange)="loadDriverRateQuote()"></p-select>
                    <label for="deliveryPayMethod">Driver pay method</label>
                </p-iftalabel></p-inputGroup>
                <p-inputGroup><p-inputGroupAddon><i class="pi pi-globe"></i></p-inputGroupAddon><p-iftalabel>
                    <p-select inputId="deliveryTripCurrency" [(ngModel)]="tripMoneyDraft.currencyCode" [options]="(workforceCurrencyOptions$ | async) || []" optionLabel="label" optionValue="value" [filter]="true" filterBy="label,value" appendTo="body" styleClass="w-full"></p-select>
                    <label for="deliveryTripCurrency">Currency *</label>
                </p-iftalabel></p-inputGroup>
                @if (tripMoneyDraft.payMethod === 'FIXED_TRIP' || tripMoneyDraft.payMethod === 'CITY_PAIR_TRIP') { <p-inputGroup><p-inputGroupAddon><i class="pi pi-money-bill"></i></p-inputGroupAddon><p-iftalabel>
                    <p-inputNumber inputId="deliveryTripEarning" [(ngModel)]="tripMoneyDraft.tripEarningAmount" mode="decimal" [min]="0.01" [minFractionDigits]="2" styleClass="w-full"></p-inputNumber>
                    <label for="deliveryTripEarning">Trip earning override</label>
                </p-iftalabel></p-inputGroup> }
                <p-inputGroup><p-inputGroupAddon><i class="pi pi-wallet"></i></p-inputGroupAddon><p-iftalabel>
                    <p-inputNumber inputId="deliveryTripCash" [(ngModel)]="tripMoneyDraft.tripCashAmount" mode="decimal" [min]="0.01" [minFractionDigits]="2" styleClass="w-full"></p-inputNumber>
                    <label for="deliveryTripCash">Cash amount (blank uses configured default)</label>
                </p-iftalabel></p-inputGroup>
            </div>
            @if (quotedDriverRate) { <small class="block mt-2">Matched driver rate: {{ quotedDriverRate | number:'1.2-2' }} {{ tripMoneyDraft.currencyCode }} {{ tripMoneyDraft.payMethod === 'PER_KM' ? 'per km' : 'per trip' }}.</small> }
            @if (driverRateMessage) { <small class="block text-orange-600 mt-2">{{ driverRateMessage }}</small> }
            @if (tripMoneyDraft.payMethod === 'PER_KM') {
                <div class="delivery-trip-money-grid mt-3">
                    <p-inputGroup><p-inputGroupAddon><i class="pi pi-calculator"></i></p-inputGroupAddon><p-iftalabel><p-inputNumber inputId="deliveryRatePerKm" [(ngModel)]="tripMoneyDraft.ratePerKm" [min]="0.01" [minFractionDigits]="2" styleClass="w-full"></p-inputNumber><label for="deliveryRatePerKm">Pay per km</label></p-iftalabel></p-inputGroup>
                    <p-inputGroup><p-inputGroupAddon><i class="pi pi-map"></i></p-inputGroupAddon><p-iftalabel><p-select inputId="deliveryDistanceSource" [(ngModel)]="tripMoneyDraft.distanceSource" [options]="payDistanceSources" optionLabel="label" optionValue="value" appendTo="body" styleClass="w-full"></p-select><label for="deliveryDistanceSource">Distance source *</label></p-iftalabel></p-inputGroup>
                    <p-inputGroup><p-inputGroupAddon><i class="pi pi-map-marker"></i></p-inputGroupAddon><p-iftalabel><input id="deliveryPayStart" pInputText [(ngModel)]="tripMoneyDraft.expectedStartPlace"><label for="deliveryPayStart">Start before pickup</label></p-iftalabel></p-inputGroup>
                    <p-inputGroup><p-inputGroupAddon><i class="pi pi-flag"></i></p-inputGroupAddon><p-iftalabel><input id="deliveryPayEnd" pInputText [(ngModel)]="tripMoneyDraft.expectedParkingPlace"><label for="deliveryPayEnd">End parking place</label></p-iftalabel></p-inputGroup>
                    <p-inputGroup><p-inputGroupAddon><i class="pi pi-link"></i></p-inputGroupAddon><p-iftalabel><input id="deliveryPayGroup" pInputText [(ngModel)]="tripMoneyDraft.payTripGroupKey"><label for="deliveryPayGroup">Trip group (same shipment)</label></p-iftalabel></p-inputGroup>
                </div>
                @if (shipment?.distance && tripMoneyDraft.ratePerKm) { <small class="block mt-2">Planned estimate: {{ (shipment.distance || 0) * tripMoneyDraft.ratePerKm | number:'1.2-2' }} {{ tripMoneyDraft.currencyCode }} for {{ shipment.distance | number:'1.1-1' }} km. Final pay uses the reviewed distance.</small> }
            }
            <p-inputGroup class="mt-3"><p-inputGroupAddon><i class="pi pi-list"></i></p-inputGroupAddon><p-iftalabel>
                <p-select inputId="deliveryTripCashPurpose" [(ngModel)]="tripMoneyDraft.cashPurpose" [options]="cashPurposeOptions" optionLabel="label" optionValue="value" appendTo="body" styleClass="w-full"></p-select>
                <label for="deliveryTripCashPurpose">Cash purpose</label>
            </p-iftalabel></p-inputGroup>
            <small class="block text-color-secondary mt-1">Choose explicitly. Cash is issued later by a custodian.</small>
            @if (tripMoneyDraft.cashPurpose !== 'NONE') {
            <p-inputGroup class="mt-3"><p-inputGroupAddon><i class="pi pi-map-marker"></i></p-inputGroupAddon><p-iftalabel>
                <p-select inputId="deliveryTripCashBox" [(ngModel)]="tripMoneyDraft.pettyCashBoxId" [options]="availableCashBoxes(tripMoneyDraft.currencyCode)" optionLabel="boxName" optionValue="pettyCashBoxId" [filter]="true" filterBy="boxName,locationName" appendTo="body" styleClass="w-full">
                    <ng-template pTemplate="item" let-box>{{ box.boxName }} · {{ box.locationName || 'Location not recorded' }}</ng-template>
                    <ng-template pTemplate="selectedItem" let-box>{{ box?.boxName }} · {{ box?.locationName }}</ng-template>
                </p-select>
                <label for="deliveryTripCashBox">Cash from box / location *</label>
            </p-iftalabel></p-inputGroup>
            @if (cashBoxError) { <small class="block text-red-500">{{ cashBoxError }}</small> }
            }
            <p-inputGroup class="mt-3"><p-inputGroupAddon><i class="pi pi-comment"></i></p-inputGroupAddon><p-iftalabel>
                <textarea pTextarea id="deliveryTripReason" [(ngModel)]="tripMoneyDraft.reason" rows="4" class="w-full" [autoResize]="true"></textarea>
                <label for="deliveryTripReason">Override reason *</label>
            </p-iftalabel></p-inputGroup>
            <small class="text-color-secondary">A reason is required when the driver rate or cash amount differs from its configured default.</small>
            }
            @if (tripMoneyError) { <div class="dialog-error mt-3"><i class="pi pi-exclamation-circle"></i><span>{{ tripMoneyError }}</span></div> }
        </section>
    </section>
    <ng-template pTemplate="footer">
        <div class="master-dialog-footer"><p-button label="Cancel" icon="pi pi-times" severity="secondary" [outlined]="true" (onClick)="tripMoneyDialogVisible = false" [disabled]="tripMoneySaving"></p-button><span class="footer-spacer"></span><p-button label="Save trip money draft" icon="pi pi-save" (onClick)="saveTripMoney()" [loading]="tripMoneySaving"></p-button></div>
    </ng-template>
</p-dialog>

<p-dialog
    header="Change Driver / Vehicle"
    [(visible)]="crewAssetDialogVisible"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [style]="{ width: '760px', maxWidth: '96vw' }"
    (onHide)="closeCrewAssetDialog()">
    <div class="crew-change-dialog">
        <div class="crew-change-summary">
            <div>
                <span>Current Driver</span>
                <strong>{{ driverName() }}</strong>
            </div>
            <div>
                <span>Current Vehicle</span>
                <strong>{{ vehiclePlateNumber() }}</strong>
            </div>
        </div>

        <div class="crew-change-fields">
            <label>
                <span>Driver</span>
                <p-select
                    [options]="availableDrivers"
                    [(ngModel)]="selectedReplacementDriver"
                    [appendTo]="'body'"
                    panelStyleClass="asset-select-panel"
                    dataKey="id"
                    optionLabel="legalName"
                    [filter]="true"
                    filterBy="name,legalName,phoneNumber,emailAddress,licenseNumber,residenceNumber,currentVehicle.plateNumber"
                    [loading]="crewAssetOptionsLoading"
                    placeholder="Select driver"
                    styleClass="asset-select-control"
                    (onChange)="refreshCrewAssetNote()">
                    <ng-template pTemplate="selectedItem" let-driver>
                        <div class="asset-selected-card" *ngIf="driver">
                            <div class="asset-selected-inline">
                                <strong class="asset-selected-name">{{ driverOptionLabel(driver) }}</strong>
                                <p-tag [value]="replacementOwnershipLabel(driver)" [severity]="replacementOwnershipSeverity(driver)"></p-tag>
                            </div>
                            <small class="asset-selected-subline">{{ replacementDriverOwnerLine(driver) }}</small>
                        </div>
                    </ng-template>
                    <ng-template pTemplate="item" let-driver>
                        <div class="asset-option-card">
                            <div class="asset-option-head">
                                <div class="asset-primary">
                                    <strong>{{ driver.legalName || driver.name }}</strong>
                                    <span>{{ replacementDriverOwnerLine(driver) }}</span>
                                </div>
                                <p-tag [value]="replacementOwnershipLabel(driver)" [severity]="replacementOwnershipSeverity(driver)"></p-tag>
                            </div>
                            <div class="asset-metric-grid">
                                <div class="asset-metric">
                                    <label>Source</label>
                                    <strong>{{ replacementDriverSourceLine(driver) }}</strong>
                                </div>
                                <div class="asset-metric">
                                    <label>Phone / Vehicle</label>
                                    <strong>{{ replacementDriverContextLine(driver) }}</strong>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </p-select>
            </label>

            <label>
                <span>Vehicle</span>
                <p-select
                    [options]="availableVehicles"
                    [(ngModel)]="selectedReplacementVehicle"
                    [appendTo]="'body'"
                    panelStyleClass="asset-select-panel"
                    dataKey="vehicleId"
                    optionLabel="plateNumber"
                    [filter]="true"
                    filterBy="plateNumber,registrationNumber,engineNumber,currentDriver.name,currentDriver.legalName,currentDriver.phoneNumber"
                    [loading]="crewAssetOptionsLoading"
                    placeholder="Select vehicle"
                    styleClass="asset-select-control"
                    (onChange)="refreshCrewAssetNote()">
                    <ng-template pTemplate="selectedItem" let-vehicle>
                        <div class="asset-selected-card" *ngIf="vehicle">
                            <div class="asset-selected-inline">
                                <strong class="asset-selected-name">{{ vehicleOptionLabel(vehicle) }}</strong>
                                <p-tag [value]="replacementOwnershipLabel(vehicle)" [severity]="replacementOwnershipSeverity(vehicle)"></p-tag>
                            </div>
                            <small class="asset-selected-subline">{{ replacementVehicleOwnerLine(vehicle) }}</small>
                        </div>
                    </ng-template>
                    <ng-template pTemplate="item" let-vehicle>
                        <div class="asset-option-card">
                            <div class="asset-option-head">
                                <div class="asset-primary">
                                    <strong>{{ vehicle.plateNumber }}</strong>
                                    <span>{{ replacementVehicleOwnerLine(vehicle) }}</span>
                                </div>
                                <p-tag [value]="replacementOwnershipLabel(vehicle)" [severity]="replacementOwnershipSeverity(vehicle)"></p-tag>
                            </div>
                            <div class="asset-metric-grid">
                                <div class="asset-metric">
                                    <label>Source</label>
                                    <strong>{{ replacementVehicleSourceLine(vehicle) }}</strong>
                                </div>
                                <div class="asset-metric">
                                    <label>Type / Driver</label>
                                    <strong>{{ replacementVehicleContextLine(vehicle) }}</strong>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </p-select>
            </label>
        </div>

        <div class="crew-change-fields crew-finance-confirmation">
            <label>
                <span>Confirmed transport cost *</span>
                <p-inputNumber
                    [(ngModel)]="crewAssetTransportCostAmount"
                    mode="currency"
                    [currency]="transportCostCurrencyCode()"
                    [min]="0"
                    [minFractionDigits]="2"
                    styleClass="asset-select-control">
                </p-inputNumber>
                <small>{{ replacementFinanceChannelLabel() }}. This changes only the generated transport charge.</small>
            </label>
        </div>

        <div class="crew-note-editor">
            <span>Reason for change *</span>
            <p-editor [(ngModel)]="crewAssetNoteHtml" [style]="{ height: '220px' }" styleClass="crew-rich-editor">
                <ng-template pTemplate="header">
                    <span class="ql-formats">
                        <select class="ql-header" aria-label="Text style">
                            <option value="1">Heading</option>
                            <option value="2">Subheading</option>
                            <option selected>Normal</option>
                        </select>
                    </span>
                    <span class="ql-formats">
                        <button class="ql-bold note-toolbar-button" aria-label="Bold" type="button">B</button>
                        <button class="ql-italic note-toolbar-button" aria-label="Italic" type="button"><em>I</em></button>
                        <button class="ql-underline note-toolbar-button" aria-label="Underline" type="button"><u>U</u></button>
                    </span>
                    <span class="ql-formats">
                        <button class="ql-list note-toolbar-button" value="ordered" aria-label="Numbered list" type="button">1.</button>
                        <button class="ql-list note-toolbar-button" value="bullet" aria-label="Bullet list" type="button">â€¢</button>
                    </span>
                    <span class="ql-formats">
                        <button class="ql-link note-toolbar-button" aria-label="Insert link" type="button">Link</button>
                        <button class="ql-clean note-toolbar-button" aria-label="Clear formatting" type="button">Clear</button>
                    </span>
                </ng-template>
            </p-editor>
        </div>
    </div>

    <ng-template pTemplate="footer">
        <p-button label="Cancel" severity="secondary" [text]="true" (onClick)="closeCrewAssetDialog()"
            [disabled]="crewAssetSaveInProgress"></p-button>
        <p-button label="Save & Regenerate Waybill" icon="fa-solid fa-rotate" (onClick)="saveCrewAssetChange()"
            [disabled]="!hasCrewAssetChange()" [loading]="crewAssetSaveInProgress"></p-button>
    </ng-template>
</p-dialog>

<p-dialog [(visible)]="historicalWaybillDialogVisible" [header]="'pages.deliveryDetail.historicalEntry.title' | transloco" [modal]="true" [draggable]="false"
    [resizable]="false" [closable]="!historicalWaybillBusy" [closeOnEscape]="!historicalWaybillBusy"
    [style]="{ width: 'min(980px, 94vw)' }" [breakpoints]="{ '860px': '96vw' }"
    styleClass="master-create-dialog">
    <section class="master-dialog-body">
        <aside class="master-dialog-summary">
            <div class="summary-icon"><i class="pi pi-file"></i></div>
            <div><small>{{ 'pages.deliveryDetail.historicalEntry.eyebrow' | transloco }}</small><h3>{{ 'pages.deliveryDetail.historicalEntry.title' | transloco }}</h3>
                <p>{{ 'pages.deliveryDetail.historicalEntry.instructions' | transloco }}</p></div>
            <div class="master-dialog-facts"><div><span>{{ 'pages.deliveryDetail.historicalEntry.delivery' | transloco }}</span><strong>{{ shipmentDelivery?.deliveryNumber }}</strong></div>
                <div><span>{{ 'pages.deliveryDetail.historicalEntry.current' | transloco }}</span><strong>{{ historicalWaybillExpected || ('pages.deliveryDetail.historicalEntry.missing' | transloco) }}</strong></div></div>
        </aside>
        <div class="master-dialog-form">
            @if (historicalWaybillError) { <small class="p-error master-wide-field">{{ historicalWaybillError }}</small> }
            @if (!historicalSiteOptions().length) { <p class="master-wide-field">{{ 'pages.deliveryDetail.historicalEntry.noSite' | transloco }}</p> }
            <p-inputGroup class="master-wide-field">
                <p-inputGroupAddon><i class="pi pi-map-marker"></i></p-inputGroupAddon>
                <p-iftalabel><p-select inputId="historicalWaybillSite" [options]="historicalSiteOptions()"
                    optionLabel="label" optionValue="value" [(ngModel)]="historicalWaybillStopId"
                    (onChange)="historicalWaybillSiteChanged()" [disabled]="historicalWaybillBusy || historicalNumberLoading || historicalFilesLoading"
                    appendTo="body" styleClass="w-full"></p-select><label for="historicalWaybillSite">{{ 'pages.deliveryDetail.historicalEntry.site' | transloco }}</label></p-iftalabel>
            </p-inputGroup>
            <p-button class="master-wide-field" [label]="'pages.deliveryDetail.historicalEntry.refresh' | transloco" icon="pi pi-refresh" [outlined]="true" severity="secondary"
                [loading]="historicalNumberLoading" [disabled]="!historicalWaybillStopId || historicalWaybillBusy" (onClick)="refreshHistoricalWaybillNumber()"></p-button>
            <p-inputGroup class="master-wide-field">
                <p-inputGroupAddon><i class="pi pi-file"></i></p-inputGroupAddon>
                <p-iftalabel><p-select inputId="historicalWaybillFile" [options]="historicalFileOptions()"
                    optionLabel="label" optionValue="value" [(ngModel)]="historicalWaybillAttachmentId"
                    [disabled]="!historicalWaybillStopId || historicalFilesLoading || historicalWaybillBusy"
                    appendTo="body" styleClass="w-full"></p-select><label for="historicalWaybillFile">{{ 'pages.deliveryDetail.historicalEntry.file' | transloco }}</label></p-iftalabel>
            </p-inputGroup>
            <p-button class="master-wide-field" [label]="'pages.deliveryDetail.historicalEntry.upload' | transloco" icon="pi pi-upload" [outlined]="true"
                [disabled]="!historicalWaybillStopId || historicalFilesLoading || historicalWaybillBusy" (onClick)="uploadHistoricalFile()"></p-button>
            @if (!historicalFilesReady && !historicalFilesLoading) {
                <p-button class="master-wide-field" [label]="'pages.deliveryDetail.historicalEntry.refreshFiles' | transloco" icon="pi pi-refresh"
                    [outlined]="true" severity="secondary" (onClick)="refreshHistoricalFiles()"></p-button>
            }
            <p-inputGroup class="master-wide-field">
                <p-inputGroupAddon><i class="pi pi-hashtag"></i></p-inputGroupAddon>
                <p-iftalabel><input pInputText id="historicalWaybillNumber" [(ngModel)]="historicalWaybillNumber"
                    [disabled]="!historicalWaybillStopId || historicalWaybillBusy" maxlength="100" class="w-full">
                    <label for="historicalWaybillNumber">{{ 'pages.deliveryDetail.historicalEntry.number' | transloco }}</label></p-iftalabel>
            </p-inputGroup>
        </div>
    </section>
    <ng-template pTemplate="footer"><div class="master-dialog-footer"><span class="footer-spacer"></span>
        <p-button [label]="'pages.deliveryDetail.historicalEntry.cancel' | transloco" severity="secondary" [outlined]="true" [disabled]="historicalWaybillBusy" (onClick)="historicalWaybillDialogVisible = false"></p-button>
        <p-button [label]="'pages.deliveryDetail.historicalEntry.save' | transloco" icon="pi pi-check" [loading]="historicalWaybillBusy"
            [disabled]="!historicalWaybillStopId || !historicalWaybillAttachmentId || !historicalWaybillNumber.trim() || !historicalFilesReady || historicalFilesLoading || historicalNumberLoading"
            (onClick)="saveHistoricalWaybillNumber()"></p-button></div></ng-template>
</p-dialog>

<app-delivery-cancellation-dialog
    [visible]="deliveryCancellationDialogVisible"
    [deliveryNumber]="shipmentDelivery?.deliveryNumber"
    [reason]="deliveryCancellationReason"
    [saving]="deliveryCancellationInProgress"
    (visibleChange)="deliveryCancellationDialogVisible = $event"
    (reasonChange)="deliveryCancellationReason = $event"
    (confirmed)="cancelCurrentDelivery()">
</app-delivery-cancellation-dialog>

<app-historical-completion-dialog
    [visible]="historicalCompletionDialogVisible"
    [completionDate]="historicalCompletionDate"
    [overrideReason]="historicalCompletionOverrideReason"
    [saving]="historicalCompletionInProgress"
    (visibleChange)="historicalCompletionDialogVisible = $event"
    (completionDateChange)="historicalCompletionDate = $event"
    (overrideReasonChange)="historicalCompletionOverrideReason = $event"
    (confirmed)="submitHistoricalCompletion()">
</app-historical-completion-dialog>

<app-charge-line-dialog *ngIf="canViewShipmentPricing()" [chargeLineDialogVisible]="chargeLineDialogVisible" [shipment]="shipment"
    [selectedDelivery]="this.shipmentDelivery" [selectedChargeLine]="selectedChargeLine"
    [saveChargeLineInProgress]="saveChargeLineInProgress" (onHide)="hideChargeLineDialog()"
    (onSave)="saveChargeLine($event)">
</app-charge-line-dialog>
